<template>
    <basic-container>
      <el-dialog
        title="任务明细"
        :visible.sync="openFlag"
        :modal-append-to-body="false"
        width="70%"
        @closed="handleClose"
        append-to-body
      >
        <avue-crud  v-if="reWrite"
                    :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              v-if="permission.questionnairetask_view"
              @click="openQuestionnaireTaskViewDialog(scope.row)"
            >查看
            </el-button>
          </template>
        </avue-crud>
      <el-dialog
        width="60%"
        title="查看"
        :visible.sync="openQuestionnaireTaskViewDialogFlag"
        v-if="openQuestionnaireTaskViewDialogFlag"
        append-to-body
        @close="quitQuestionnaireTaskViewDialog"
      >
        <div
          class="el-property-dialog-div">
          <avue-form
            ref="questionnaireTaskViewFormRef"
            v-model="questionnaireTaskViewForm"
            :option="questionnaireTaskViewOption"
          >
            <template  slot="test" slot-scope="scope">
              <avue-crud :data="viewTopicData" :option="topicOption"></avue-crud>
            </template>
            <template slot="testLabel" slot-scope="row">
              <span>题目内容:</span>
            </template>
          </avue-form>
        </div>
      </el-dialog>
      </el-dialog>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update, getTopicList} from "@/api/crmedical/questionnaire/task/questionnairetask";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import  questionnaireTaskViewOption from './questionnairetask-view-option';

    export default {
      data: function () {
        return {
          form: {},
          query: {},
          loading: true,
          openFlag:false,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          taskMainId:'',
          informantType:'',
          reWrite: false,
          tempProjectId: '',
          projectList: [],
          viewTopicData:[],
          questionnaireTaskViewForm: {},
          questionnaireTaskViewOption: questionnaireTaskViewOption,
          openQuestionnaireTaskViewDialogFlag: false,
          option: {
            height: 'auto',
            calcHeight: 50,
            indexLabel:'序号',
            tip: false,
            border: true,
            index: true,
            viewBtn: false,
            selection: true,
            editBtn: false,
            addBtn: false,
            delBtn: false,
            columnBtn: false,
            refreshBtn: false,
            searchMenuSpan: 6,
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "任务名称",
                prop: "name",
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
              },
              {
                label: "填报组织",
                prop: "deptName",
              },
              {
                label: "填报人",
                prop: "realName",
                search: true,
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
              },
              {
                label: "任务状态",
                prop: "processStatus",
                type: 'select',
                dataType: 'number',
                search: true,
                dicUrl: 'api/blade-system/dict/dictionary?code=task_process_status',
                props: {label: 'dictValue', value: 'dictKey'},
              },
              {
                label: "提交时间",
                prop: "submitTime",
              },
              {
                label: "反馈建议",
                prop: "description",
                hide: true,
              },
              {
                label: '提交日期',
                prop: 'dateStartRange',
                searchRange: true,
                search: true,
                searchSpan: 12,
                type: 'datetimerange',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                span: 16,
                hide: true,
              },
            ]
          },
          topicOption: {
            calcHeight: 50,
            height: '400',
            indexLabel:'序号',
            page: false,
            border: true,
            addBtn: false,
            selection: false,
            tip: false,
            columnBtn: false,
            refreshBtn: false,
            menuAlign: 'center',
            menu: false,
            column: [
              {
                label: "题目名称",
                prop: "name",
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
              },
              {
                label: "题目内容",
                prop: "topic",
                span: 24,
                row: 2,
                maxlength: 200,
                showWordLimit: true,
                overHidden: true,
              },
              {
                label: "分值",
                prop: "score",
                maxlength: 6,
                showWordLimit: true,
              },
              {
                label: "排序",
                prop: "sort",
                maxlength: 6,
                showWordLimit: true,
              },
              {
                label: "评分",
                prop: "evaluateScore",
              },
            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.questionnairetask_add, false),
                    viewBtn: this.vaildData(this.permission.questionnairetask_view, false),
                    delBtn: this.vaildData(this.permission.questionnairetask_delete, false),
                    editBtn: this.vaildData(this.permission.questionnairetask_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      created() {
        //加载列表
        getProjectList({}).then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.tempProjectId = this.projectList[0].id;
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });
          //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
          this.firstDisplayFlag = true;
        });
      },
        methods: {
          //打开弹窗--------------------------------------------------------------------
          openQuestionnaireTaskViewDialog(row){
            setTimeout(()=>{
              this.questionnaireTaskViewForm = row;
              //根据任务id、填报人id获取关联题目
                getTopicList({taskId:row.id}).then((res) => {
                  this.viewTopicData = res.data;
                  if (res.data){
                    let sum = 0
                    res.data.forEach(item=>{
                      sum+= item.evaluateScore;
                    });
                    this.questionnaireTaskViewForm.sum = sum;
                  }
                });

            },500)
            this.openQuestionnaireTaskViewDialogFlag = true;
          },
          //关闭弹窗=================================================================
          quitQuestionnaireTaskViewDialog(){
            this.questionnaireTaskViewForm = {};
            this.viewTopicData = [];
            this.openQuestionnaireTaskViewDialogFlag = false;
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
              this.query.processStatus =  '';
              this.query.name = '';
              this.query.realName = '';
              this.query.dateStartRange = [];
                this.firstDisplayFlag = true;
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                done();
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            if (this.query.dateStartRange) {
              this.query.timeStart = this.query.dateStartRange[0];
              this.query.timeEnd = this.query.dateStartRange[1];
              this.query.dateStartRange = '';
            }
            //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
            // if (!this.query.projectId ) {
            //   this.query.projectId = this.tempProjectId;
            // }
            console.log(this.query.projectId);
            this.query.taskMainId = this.taskMainId;
            this.query.informantType = this.informantType;
            getList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
              if (this.firstDisplayFlag) {
                // let ent = document.querySelector('input[placeholder="项目名称"]');
                // ent.value = this.getProjectNameById(this.query.projectId);
                // this.tempProjectId = this.query.projectId
                //关闭默然显示，重刷页面时才开启默认显示
                // this.firstDisplayFlag = false;
              }
            });
          },
          openSystemTypeDialog(row) {
            this.taskMainId = row.id;
            this.informantType = row.informantType;
            this.query.taskMainId = row.id;
            this.query.informantType = row.informantType;
            this.onLoad();
            this.openFlag = true;
          },

        }
    };
</script>

<style>
</style>
